<!--login-->
<!-- <div class="form p-4"> 
    <app-alert></app-alert>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div *ngIf="enumEtapa.Login==etapa">
            <div class="form-group">
                <input type="text" class="form-input mat-input form-control" name="rut" formControlName="rut"
                    [ngClass]="{ 'is-invalid': submitted && f.rut.errors }" id="rut" placeholder="Ej: 12345678k">
                <label for="rut" class="mat-label">RUT</label>
                <div *ngIf="submitted && f.rut.errors" class="invalid-feedback pull-left">
                    <div *ngIf="f.rut.errors.required" class="pull-left">
                        El RUT es requerido
                    </div>
                </div>
                <div class="help-text">Ingresa tu Rut sin puntos ni guion</div>
            </div>

            <div class="form-group">
                <input id="password" class="form-input mat-input form-password form-control"
                    [type]="fieldTextType ? 'text' : 'password'" placeholder="Contraseña" name="password"
                    formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                <label class="mat-label" for="password">Contraseña / Número interno</label>
                <i toggle="#password-field" class="toggle-password" (click)="toggleFieldTextType()"
                    [ngClass]="{ 'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType }"></i>
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required" class="pull-left">
                        La contraseña es requerida
                    </div>
                </div>
                <div class="help-text">Ingresa tu contraseña</div>
            </div>
        </div>
     
    
        <div class="form-group" class="form-group" *ngIf="etapa==enumEtapa.SelecionEmpresa">
          
            <input type="text" class="form-input mat-input form-control" 
                formControlName="rutEmp" [ngClass]="{ 'is-invalid': submitted && f.rutEmp.errors }"
                placeholder="Ej: 12345678k" (keyup)="onDisableButton()" (paste)="onDisableButton()">
            <label for="rutEmp" class="mat-label">Rut Empresa</label>
           
            <div class="help-text">Ingresa tu Rut de Empresa sin puntos ni guion</div>
            <div *ngIf="btnDisable" class="invalid-feedback pull-left">
                <div *ngIf="btnDisable" class="pull-left">
                    El Rut de la empresa es requerido
                </div>
            </div>
           
        </div>
    
       
        <div class="buttons">
            <button class="btn btn-primary" id="formButton" type="submit" [disabled]="!loginForm.valid">Ingresar</button>
        </div>
    </form>

</div> -->

<div class="login-container">


<div class="login-image d-none d-md-block">
  <div class="login-carousel">
    <div class="login-track">
      <!-- originales -->
      <div class="login-slide s1"></div>
      <div class="login-slide s2"></div>
      <!-- duplicadas (para loop infinito) -->
      <div class="login-slide s1"></div>
      <div class="login-slide s2"></div>
    </div>
  </div>
</div>



    <!-- Formulario lado derecho -->
    <div class="login-form">
        <div class="form-box">
            <app-alert></app-alert>
            <div class="text-center">
                <app-toast #toast></app-toast>
                <img src="../assets/images/html/logo-login.png" alt="Polpaico" class="logo">
            </div>
            <div class="">

                <h3>¡Bienvenido!</h3>
                <p class="">Ingresa tu RUT y contraseña para continuar.</p>
            </div>
            <form form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="rut">RUT personal</label>
                    <input type="text" class="form-input form-control" id="rut" name="rut" formControlName="rut"
                        [ngClass]="{ 'is-invalid': submitted && f.rut.errors}" placeholder="12345678K">

                    <div *ngIf="f.rut.errors" class="invalid-feedback">
                        <div *ngIf="f.rut.errors.required" class="pull-left">
                            El Rut es requerido
                        </div>
                        <div *ngIf="f.rut.errors.pattern" class="pull-left">
                            Ingrese un Rut valido (sin puntos ni guiones).
                        </div>

                    </div>
                </div>

                <div class="form-group">
                    <label for="password">Contraseña</label>
                    <div class="password-field">
                        <input id="password" class="form-input  form-control"
                            [type]="fieldTextType ? 'text' : 'password'" placeholder="Contraseña" name="password"
                            formControlName="password"
                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }">

                        <i class="fa toggle-password position-absolute eye-form"
                            [ngClass]="{ 'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType }"
                            (click)="toggleFieldTextType()"></i>

                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required" class="pull-left">
                                La contraseña es requerida
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="recordar">
                        <label class="form-check-label" for="recordar">Recordar cuenta</label>
                    </div>
                    <a href="javascript:void(0)" (click)="openForgotPassword()">Olvidé mi contraseña</a>
                </div>
                <button id="formButton" type="submit" class="btn btn-primary btn-block">Iniciar sesión</button>
            </form>
        </div>




    </div>


</div>

<!-- Footer ahora está fuera del login-container -->
<div class="footer">
    <img src="../assets/images/html/logo-footer.png" alt="Logo" class="footer-logo">
</div>

<app-modal-info #modalInfo [title]="modalTitle" [message]="modalMessage" [buttonText]="'Aceptar'"></app-modal-info>

